module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ne-64f5ff142997ea42d42e58f1831693bc.svg";